var map = {
	"./2arrow.svg": 51538,
	"./UserIcons.svg": 67684,
	"./add_icon.svg": 56252,
	"./alert-triangle-new.svg": 53901,
	"./alertCircle.svg": 13335,
	"./arrow.svg": 89090,
	"./arrow_d.svg": 18471,
	"./arrow_l.svg": 48047,
	"./arrow_r.svg": 46761,
	"./award.svg": 49266,
	"./bag-new.svg": 23374,
	"./bag.svg": 71787,
	"./banSigh.svg": 75263,
	"./barrier-new.svg": 82277,
	"./barrier2-new.svg": 98247,
	"./boxBlack-new.svg": 98282,
	"./boxBlack.svg": 47735,
	"./burger.svg": 85904,
	"./burgerClose.svg": 51636,
	"./card-new.svg": 5408,
	"./card.svg": 4525,
	"./cart-new.svg": 27632,
	"./cart.svg": 30141,
	"./chartIcon.svg": 50038,
	"./check-square.svg": 3335,
	"./checkboxActive.svg": 74926,
	"./checkbox_indeterminate.svg": 37560,
	"./checkbox_outline.svg": 50807,
	"./checked.svg": 41154,
	"./chevronDown.svg": 40940,
	"./chevronDownSort.svg": 54328,
	"./circleAsk.svg": 52778,
	"./closeCross.svg": 66539,
	"./closeCrossInBtn.svg": 94850,
	"./crossInCircle.svg": 87916,
	"./cube.svg": 42272,
	"./daw.svg": 55249,
	"./delete-not-fill.svg": 77128,
	"./delete.svg": 89510,
	"./docsIcon.svg": 11853,
	"./document-new.svg": 31433,
	"./document-redesign.svg": 65724,
	"./document.svg": 13428,
	"./documentNew.svg": 46254,
	"./download.svg": 21587,
	"./downloadBlue.svg": 82739,
	"./download_transparent.svg": 82004,
	"./dropDown.svg": 10776,
	"./expand_more.svg": 73025,
	"./export-new.svg": 77700,
	"./external-link.svg": 86115,
	"./facebook.svg": 69323,
	"./factory-new.svg": 27226,
	"./factory.svg": 96487,
	"./fileBlack.svg": 16582,
	"./fileUpload.svg": 1458,
	"./flag.svg": 76293,
	"./furgon-new.svg": 80795,
	"./furgon.svg": 1750,
	"./globe-new.svg": 6275,
	"./goodSigh.svg": 1053,
	"./green_file.svg": 3341,
	"./hide.svg": 70919,
	"./house-new.svg": 49484,
	"./ico-Eye.svg": 79490,
	"./info-bold.svg": 67913,
	"./info.svg": 38623,
	"./infoBlack.svg": 27428,
	"./kolba.svg": 5296,
	"./letter.svg": 77879,
	"./listBlack.svg": 40800,
	"./logo.svg": 69622,
	"./mail.svg": 4138,
	"./map-pin.svg": 47617,
	"./mark.svg": 88416,
	"./marketAccessChevron.svg": 95262,
	"./mode.svg": 33486,
	"./moneyIcon.svg": 63098,
	"./more-info.svg": 36881,
	"./pen_transparent.svg": 65843,
	"./person.svg": 4064,
	"./personAuth.svg": 36650,
	"./personMob.svg": 77754,
	"./phone.svg": 39165,
	"./pie-chart.svg": 99456,
	"./pie-chart2.svg": 39442,
	"./pipetka.svg": 20701,
	"./play-circle.svg": 29310,
	"./plus-mini.svg": 59141,
	"./radio.svg": 27764,
	"./radioActive.svg": 15122,
	"./result.svg": 37316,
	"./search.svg": 45539,
	"./send.svg": 66429,
	"./shopping-bag-new.svg": 79975,
	"./show.svg": 70524,
	"./social-dz.svg": 76513,
	"./social-ok.svg": 52485,
	"./social-tg.svg": 29844,
	"./social-vk.svg": 83770,
	"./social-yt.svg": 79736,
	"./tShirt.svg": 72639,
	"./taxesChevron.svg": 85551,
	"./telegramm.svg": 53755,
	"./telephone.svg": 81733,
	"./tooltip.svg": 38256,
	"./twitter.svg": 1476,
	"./uploadImage.svg": 49971,
	"./user-check-new.svg": 78240,
	"./usersBlack.svg": 57718,
	"./vertical_split.svg": 40948,
	"./view_module.svg": 74359,
	"./vk.svg": 54626,
	"./web.svg": 29227,
	"./webHelpBot.svg": 11541,
	"./youtube.svg": 87354,
	"./сheckbox.svg": 10882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57625;